export default function countriesTreater(countries = []) {
  return countries.map((c: any) => ({ id: c.id, name: c.description }));
}
